// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".acceptable-eula .modal-container{max-height:85vh !important}.acceptable-eula .modal-body{max-height:60vh !important}", "",{"version":3,"sources":["webpack://src/views/eula/acceptable-eula.scss"],"names":[],"mappings":"AACE,kCACE,0BAAA,CAEF,6BACE,0BAAA","sourcesContent":[".acceptable-eula {\n  .modal-container {\n    max-height: 85vh !important;\n  }\n  .modal-body {\n    max-height: 60vh !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
